module.exports = __webpack_public_path__ + "../resources/images/illustration_drink-a077acbd90a5e21883469e2bd8997622.svg";